// src/pages/Dashboard/components/SalesTrendChart.js
import React from "react";
import { Card, Empty } from "antd";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import ChartTooltip from "./ChartTooltip";
import { SERIES, INK, axisTick, shortAmount } from "../dashboardTheme";

const SalesTrendChart = ({ data = [], currency, isMobile }) => {
  const chartHeight = isMobile ? 150 : 170;
  const total = data.reduce((s, d) => s + Number(d.sales || 0), 0);

  return (
    <Card className="erp-card" variant="borderless">
      <div className="erp-card-head">
        <div>
          <div className="erp-card-title">Sales Trend</div>
          <div className="erp-card-sub">
            <b className="erp-card-figure">{shortAmount(total)}</b> {currency} over the last 7 months
          </div>
        </div>
      </div>

      {!data.length ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No sales recorded" className="erp-empty" />
      ) : (
        <div className="erp-chart">
          <ResponsiveContainer width="100%" height={chartHeight}>
            <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="erpSalesFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={SERIES.blue} stopOpacity={0.22} />
                  <stop offset="100%" stopColor={SERIES.blue} stopOpacity={0.02} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke={INK.grid} strokeOpacity={0.7} vertical={false} />
              <XAxis
                dataKey="month"
                tickLine={false}
                axisLine={{ stroke: INK.axis }}
                tick={axisTick}
                tickFormatter={(m) => (isMobile ? String(m).slice(0, 3) : m)}
                interval="preserveStartEnd"
              />
              <YAxis
                width={isMobile ? 44 : 56}
                tickLine={false}
                axisLine={false}
                tick={axisTick}
                tickFormatter={shortAmount}
                domain={[(dataMin) => (dataMin < 0 ? dataMin : 0), "auto"]}
              />
              <Tooltip
                content={<ChartTooltip currency={currency} />}
                cursor={{ stroke: INK.axis, strokeDasharray: "3 3" }}
              />
              <Area
                type="monotone"
                dataKey="sales"
                name="Sales"
                stroke={SERIES.blue}
                strokeWidth={2}
                fill="url(#erpSalesFill)"
                dot={{ r: 3, fill: SERIES.blue, stroke: "#fff", strokeWidth: 2 }}
                activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2, fill: SERIES.blue }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
};

export default SalesTrendChart;
